module.exports = __webpack_public_path__ + "img/signal.c3cab900.jpg";